import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static values = {
    requiredInputs: Boolean,
  };

  static targets = [
    'employeeFieldsBlock',
    'professionalStatus',
    'freelanceFieldsBlock',
  ];

  connect() {
    function forwardSelectChange() {
      const event = new Event('change', { bubbles: true });
      this.dispatchEvent(event);
    }

    $(this.professionalStatusTarget).on(
      'select2:select select2:unselect',
      forwardSelectChange
    );

    this.adaptFieldsToProfessionalStatus();
  }

  adaptFieldsToProfessionalStatus() {
    if (
      $(this.professionalStatusTarget).val().includes('employee') ||
      $(this.professionalStatusTarget).val().includes('business_owner')
    ) {
      this.employeeFieldsBlockTarget.classList.remove('d-none');
      $(this.employeeFieldsBlockTarget)
        .find('input,select,textarea')
        .prop('disabled', false);

      if (this.requiredInputsValue) {
        $(this.employeeFieldsBlockTarget)
          .find('input,select,textarea')
          .prop('required', true);
      }
    } else {
      this.employeeFieldsBlockTarget.classList.add('d-none');
      $(this.employeeFieldsBlockTarget)
        .find('input,select,textarea')
        .prop('disabled', true);
      $(this.employeeFieldsBlockTarget)
        .find('input,select,textarea')
        .prop('required', false);
    }

    if ($(this.professionalStatusTarget).val().includes('freelance')) {
      this.freelanceFieldsBlockTarget.classList.remove('d-none');
      $(this.freelanceFieldsBlockTarget)
        .find('input,select,textarea')
        .prop('disabled', false);

      if (this.requiredInputsValue) {
        $(this.freelanceFieldsBlockTarget)
          .find('input,select,textarea')
          .prop('required', true);
      }
    } else {
      this.freelanceFieldsBlockTarget.classList.add('d-none');
      $(this.freelanceFieldsBlockTarget)
        .find('input,select,textarea')
        .prop('disabled', true);
      $(this.freelanceFieldsBlockTarget)
        .find('input,select,textarea')
        .prop('required', false);
    }
  }
}
